/** Session bridge: Password Generator → QR Code (plain text payload). */
export const PASSWORD_TO_QR_KEY = 'vorakit_password_to_qr';

export function sendPasswordToQrGenerator(password) {
  const str = String(password ?? '');
  try {
    sessionStorage.setItem(PASSWORD_TO_QR_KEY, JSON.stringify({ text: str }));
  } catch (_) {
    /* quota / private mode */
  }
}
